<email-layout>
  <ng-container logo>
    <email-tellent-grow-logo />
  </ng-container>

  <ng-container header>
    <ng-container>
      <email-message-header [subheader]="data.header_html" [separator]="true" />
    </ng-container>
  </ng-container>

  <ng-container body>
    <email-text [contents]="data.step_name" presetName="header" />
    <email-text [contents]="data.step_description" presetName="paragraph" />
    <ng-container *mailgunIf="data.primary_cta">
      <email-margin [height]="28" />
      <email-button
        [href]="data.primary_cta?.href!"
        [label]="data.primary_cta?.label!"
        theme="primary"
      />
    </ng-container>
  </ng-container>

  <ng-container footer>
    <email-text
      [contents]="data.footer.text"
      color="light"
      presetName="inline"
      size="small"
    />&nbsp;
    <email-link
      [label]="data.footer.label"
      [href]="data.footer.href"
      target="_blank"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
    <email-margin [height]="16" />
    <email-tellent-products-footer />
  </ng-container>
</email-layout>
